// ----------------------------------------------------------------
// Segmented-pill slider: move the .products-feed__tab-pill /
// .collections-feed__tab-pill highlight to the active tab button.
// ----------------------------------------------------------------
function moveTabPill(container) {
  if (!container) return;
  const pill = container.querySelector(
    '.products-feed__tab-pill, .collections-feed__tab-pill'
  );
  const activeBtn = container.querySelector('button.active');
  if (!pill || !activeBtn) return;

  // offsetLeft is relative to the nearest positioned ancestor — the
  // container itself, since CSS sets it to position: relative.
  const left = activeBtn.offsetLeft;
  const width = activeBtn.offsetWidth;

  pill.style.transform = 'translateX(' + left + 'px)';
  pill.style.width = width + 'px';
  container.setAttribute('data-pill-ready', '');
}

function moveTabPillFromButton(btn) {
  if (!btn) return;
  const container = btn.closest(
    '.products-feed__tab, .collections-feed__tab'
  );
  moveTabPill(container);
}

function refreshAllTabPills() {
  document
    .querySelectorAll('.products-feed__tab, .collections-feed__tab')
    .forEach(moveTabPill);
}

// Keep pills aligned on viewport resize (font reflow, breakpoints)
let _tabPillResizeTimer = null;
window.addEventListener('resize', () => {
  clearTimeout(_tabPillResizeTimer);
  _tabPillResizeTimer = setTimeout(refreshAllTabPills, 80);
});

// Re-run once webfonts settle so the pill matches final button widths
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => refreshAllTabPills());
}

function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    'products-feed__tabcontent--' + sectionId
  );
  const collectionTabcontent = document.getElementsByClassName(
    'collections-feed__tabcontent--' + sectionId
  );

  // Hide product tabs
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }

  // Hide collection tabs
  for (let i = 0; i < collectionTabcontent.length; i++) {
    collectionTabcontent[i].style.display = 'none';
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    'products-feed__tablinks--' + sectionId
  );
  const collectionTablinks = document.getElementsByClassName(
    'collections-feed__tablinks--' + sectionId
  );

  // Remove active class from product tabs
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '');
  }

  // Remove active class from collection tabs
  for (let i = 0; i < collectionTablinks.length; i++) {
    collectionTablinks[i].className = collectionTablinks[i].className.replace(
      ' active',
      ''
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const activeTab = document.getElementById(tabName);
  if (activeTab) {
    activeTab.style.display = 'block';

    // Update View All button for this tab
    updateViewAllButton(sectionId, activeTab);
  }

  if (evt && evt.currentTarget) {
    evt.currentTarget.className += ' active';
    moveTabPillFromButton(evt.currentTarget);
  }
}

// Function to update the View All button based on active tab
function updateViewAllButton(sectionId, activeTabElement) {
  if (!activeTabElement) return;

  let buttonContainer = document.getElementById(
    'view-all-button--' + sectionId
  );

  // Find or create the head-buttons container
  let headButtons = document.querySelector(
    `#shopify-section-${sectionId} .section__head--buttons`
  );
  if (!headButtons) {
    // Try to find it in section__foot as well
    headButtons = document.querySelector(
      `#shopify-section-${sectionId} .section__foot .section__head--buttons`
    );
  }

  // If container doesn't exist, we need to find the section__head and create it
  if (!buttonContainer) {
    if (!headButtons) {
      const sectionHead = document.querySelector(
        `#shopify-section-${sectionId} .section__head`
      );
      if (sectionHead) {
        headButtons = document.createElement('div');
        headButtons.className = 'section__head--buttons';
        sectionHead.appendChild(headButtons);
      }
    }

    if (headButtons) {
      buttonContainer = document.createElement('div');
      buttonContainer.id = 'view-all-button--' + sectionId;
      buttonContainer.className = 'view-all-button-container';

      // Insert before swiper buttons if they exist, otherwise append
      const swiperButtons = headButtons.querySelector('.swiper-buttons');
      if (swiperButtons) {
        headButtons.insertBefore(buttonContainer, swiperButtons);
      } else {
        headButtons.appendChild(buttonContainer);
      }
    }
  }

  if (!buttonContainer) return;

  const buttonLabel = activeTabElement.dataset.viewAllLabel;
  const buttonLink = activeTabElement.dataset.viewAllLink;
  const buttonStyle = activeTabElement.dataset.viewAllStyle || 'button--filled';

  // Check if button should be shown (both label and link must be provided)
  const shouldShowButton =
    buttonLabel &&
    buttonLink &&
    buttonLabel.trim() !== '' &&
    buttonLink.trim() !== '#' &&
    buttonLink.trim() !== '';

  // Find the button link element (anchor tag with button class)
  let buttonLinkElement = buttonContainer.querySelector('a.button');

  if (!shouldShowButton) {
    // Hide button container if no valid settings
    buttonContainer.classList.add('hidden');
    if (buttonLinkElement) {
      buttonLinkElement.style.display = 'none';
    }
    // Hide the entire section__head--buttons if it only contains the button (no arrows)
    if (headButtons) {
      const swiperButtons = headButtons.querySelector('.swiper-buttons');
      if (!swiperButtons) {
        headButtons.classList.add('hidden');
      } else {
        headButtons.classList.remove('hidden');
      }
    }
    return;
  }

  // Show button container
  buttonContainer.classList.remove('hidden');

  // Ensure the section__head--buttons container is visible
  if (headButtons) {
    headButtons.classList.remove('hidden');
  }

  // Create button if it doesn't exist
  if (!buttonLinkElement) {
    buttonLinkElement = document.createElement('a');
    buttonLinkElement.href = buttonLink;
    buttonLinkElement.className = 'button ' + buttonStyle;
    buttonLinkElement.textContent = buttonLabel;
    buttonContainer.appendChild(buttonLinkElement);
  } else {
    // Update existing button
    buttonLinkElement.style.display = '';

    // Update button text/label - the text is directly inside the anchor tag
    // Check if there's an icon first
    const iconElement = buttonLinkElement.querySelector('.icon');
    if (iconElement) {
      // If there's an icon, update the text node or find the text element
      const textElement = buttonLinkElement.querySelector('.icon__text');
      if (textElement) {
        textElement.textContent = buttonLabel;
      } else {
        // If icon exists but no text element, add text after icon
        const existingText = Array.from(buttonLinkElement.childNodes).find(
          (node) => node.nodeType === 3 && node.textContent.trim()
        );
        if (existingText) {
          existingText.textContent = ' ' + buttonLabel;
        } else {
          buttonLinkElement.appendChild(
            document.createTextNode(' ' + buttonLabel)
          );
        }
      }
    } else {
      // No icon, just update the text content directly
      buttonLinkElement.textContent = buttonLabel;
    }

    // Update button link
    buttonLinkElement.href = buttonLink;

    // Update button style classes - remove existing style classes and add new one
    buttonLinkElement.className = buttonLinkElement.className
      .replace(/\s*button--(filled|outlined|text)/g, '')
      .trim();
    if (buttonStyle) {
      buttonLinkElement.className += ' ' + buttonStyle;
      buttonLinkElement.className = buttonLinkElement.className.trim();
    }
  }
}

// Collection tab function
function openCollectionTab(evt, sectionId, groupName) {
  // Hide all collection tab content
  const tabcontent = document.getElementsByClassName(
    'collections-feed__tabcontent--' + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }

  // Remove active class from all collection tab links
  const tablinks = document.getElementsByClassName(
    'collections-feed__tablinks--' + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
  }

  // Show the selected tab content and add active class to the button
  const targetTab = document.getElementById('collection-group-' + groupName);
  if (targetTab) {
    targetTab.style.display = 'block';
  }
  evt.currentTarget.classList.add('active');
  moveTabPillFromButton(evt.currentTarget);
}

// show the first tabs by default on load - data-default-open
function initializeDefaultTabs() {
  document.querySelectorAll('[data-default-open]').forEach((el) => {
    // Check if it's a collection tab
    const collectionSectionId = el.className.match(
      /collections-feed__tablinks--([\w-]+)/
    )?.[1];

    if (collectionSectionId) {
      // Handle collection tabs
      const onclickAttr = el.getAttribute('onclick');
      // Match pattern: openCollectionTab(event, 'section-id', 'group-name')
      const groupNameMatch = onclickAttr?.match(
        /openCollectionTab\([^,]+,\s*'[^']+',\s*'([^']+)'\)/
      );
      const groupName = groupNameMatch?.[1];

      if (collectionSectionId && groupName) {
        // Hide all collection tab content
        const collectionTabcontent = document.getElementsByClassName(
          'collections-feed__tabcontent--' + collectionSectionId
        );
        for (let i = 0; i < collectionTabcontent.length; i++) {
          collectionTabcontent[i].style.display = 'none';
        }

        // Remove active class from all collection tab links
        const collectionTablinks = document.getElementsByClassName(
          'collections-feed__tablinks--' + collectionSectionId
        );
        for (let i = 0; i < collectionTablinks.length; i++) {
          collectionTablinks[i].classList.remove('active');
        }

        // Show the selected tab content and add active class
        const targetTab = document.getElementById(
          'collection-group-' + groupName
        );
        if (targetTab) {
          targetTab.style.display = 'block';
          el.classList.add('active');
          moveTabPillFromButton(el);
        }
      }
      return;
    }

    // Handle product tabs
    const sectionId = el.className.match(
      /products-feed__tablinks--([\w-]+)/
    )?.[1];
    const onclickAttr = el.getAttribute('onclick');
    const blockIdMatch = onclickAttr?.match(/'([\w-]+)'/g);
    const blockId = blockIdMatch?.[1]?.replace(/'/g, '');

    if (sectionId && blockId) {
      // Find the tab content element
      const tabContent = document.getElementById(blockId);
      if (tabContent) {
        // Show the tab
        const sectionTabs = document.querySelectorAll(
          '.products-feed__tabcontent--' + sectionId
        );
        sectionTabs.forEach((tab) => (tab.style.display = 'none'));
        tabContent.style.display = 'block';

        // Update button classes
        const sectionTabLinks = document.querySelectorAll(
          '.products-feed__tablinks--' + sectionId
        );
        sectionTabLinks.forEach((link) => link.classList.remove('active'));
        el.classList.add('active');
        moveTabPillFromButton(el);

        // Update View All button
        updateViewAllButton(sectionId, tabContent);
      }
    }
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDefaultTabs);
} else {
  initializeDefaultTabs();
}

window.addEventListener('shopify:section:load', () => {
  setTimeout(initializeDefaultTabs, 100);
});
